import { formatInTimeZone } from "date-fns-tz";

export const isTeam = (member) => {
  return member.additional_roles && member.additional_roles.length > 0;
};

export const getZonedTimeFormatted = (utcDate, format = "yyyy-MM-dd HH:mm") => {
  if (!utcDate) {
    return "";
  }
  return formatInTimeZone(
    convertLocalDateToUTCIgnoringTimezone(new Date(utcDate)),
    Intl.DateTimeFormat().resolvedOptions().timeZone,
    format
  );
};

export function convertLocalDateToUTCIgnoringTimezone(date) {
  const timestamp = Date.UTC(
    date.getFullYear(),
    date.getMonth(),
    date.getDate(),
    date.getHours(),
    date.getMinutes(),
    date.getSeconds(),
    date.getMilliseconds()
  );

  return new Date(timestamp);
}

export function convertUTCToLocalDateIgnoringTimezone(utcDate) {
  return new Date(
    utcDate.getUTCFullYear(),
    utcDate.getUTCMonth(),
    utcDate.getUTCDate(),
    utcDate.getUTCHours(),
    utcDate.getUTCMinutes(),
    utcDate.getUTCSeconds(),
    utcDate.getUTCMilliseconds()
  );
}
